import React, { Fragment, useRef, useEffect, useState } from "react";
import * as httpService from "../services/httpService";
import { Employee_Api_EndPoints } from "../global/end-points";
import * as userService from "../utils/userService";
import LoadingSpinner from "../components/common/loadingSpinner";
import { Link } from "react-router-dom";

function Logout() {
  const [isLoad, setIsLoad] = useState(false);
  const didMount = useRef(false);

  useEffect(() => {
    if (!didMount.current) {
      fnLogout();
    }
    return () => {
      didMount.current = true;
    };
  }, []);

  const fnLogout = async () => {
    try {
      const userId = sessionStorage.UserId;
      const accessToken = sessionStorage.AccessToken;
      const oboUserId = sessionStorage.OnBehalfUserId;
      const oboAccessToken = sessionStorage.OnBehalfAccessToken;

      if (!userId && !oboUserId) {
        userService.ClearCookies();
        return;
      }

      const logoutRequests = [];

      if (userId) {
        logoutRequests.push(
          httpService.Post(Employee_Api_EndPoints.LOGOUT, {
            UserId: Number(userId),
            AccessToken: accessToken,
          })
        );
      }

      if (oboUserId) {
        logoutRequests.push(
          httpService.Post(Employee_Api_EndPoints.LOGOUT, {
            UserId: Number(oboUserId),
            AccessToken: oboAccessToken,
          })
        );
      }

      // Wait for all logouts
      await Promise.allSettled(logoutRequests);

      // ✅ Show logout screen
      setIsLoad(true);

      // ✅ Clear storage but DO NOT redirect automatically
      localStorage.clear();
      sessionStorage.clear();

    } catch (err) {
      console.error("Logout error:", err);
      userService.ClearCookies();
      window.location.href = "/";
    }
  };






  return (
    <Fragment>
      {isLoad && (
        <Fragment>
          <div className="container">
            <div className="dashboard-container">
              
              <h5 className="text-center color-white mb-5">
                You successfully Logged Out
              </h5>
              <h1 className="text-center color-orange mb-10">See you soon!</h1>
              <p className="text-center color-primary-blue mb-20">
                Please click below link, it will take to login screen
              </p>
              <h4 className="color-white text-center">
                Want to login?{" "}
                <Link to="/" className="color-orange text-decoration-none">
                  Click here
                </Link>{" "}
                to go home page
              </h4>
            </div>
          </div>
        </Fragment>
      )}
      {!isLoad && <LoadingSpinner />}
    </Fragment>
  );
}
export default Logout;
